import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Paper,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Card from "./Card";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import "./LoginPage.css";
import useAuth from "../hooks/useAuth";
import userProfile from "../assets/user_profile.svg";
import favicon from "../assets/favicon.png";

const LoginPage = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { setAuth } = useAuth();

  const [enteredNameIsTouched, setEnteredNameIsTouched] = useState(false);
  const [enteredPasswordIsTouched, setEnteredPasswordIsTouched] =
    useState(false);
  const enteredNameIsValid = userName.trim() !== "";
  const enteredPasswordIsValid = password.length > 3;
  const nameInputIsValid = !enteredNameIsValid && enteredNameIsTouched;
  const passwordInputIsValid =
    !enteredPasswordIsValid && enteredPasswordIsTouched;
  const userRef = useRef();
  const navigate = useNavigate();

  const passwordRef = useRef();

  const enabled = userName.length > 0 && password.length > 0;

  const handleInputChange = (e) => {
    setUserName(e.target.value);
  };

  const hideShowPassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    userRef.current.focus();
  }, []);

  const LOGIN_URL = "api/auth/v1/login";

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ username: userName, password: password }),
        {
          headers: {
            "Content-Type": "application/json",
            "Time-Zone": `${timeZone}`,
          },
          withCredentials: false,
        }
      );
      const access_token = response?.data?.access_token;
      const roles = response?.data?.role;
      const refresh_token = response?.data?.refresh_token;
      const user_name = response?.data?.user_name;
      setAuth({ user_name, password, roles, access_token, refresh_token });
      setUserName("");
      setPassword("");
      if (roles === "admin") {
        navigate("/admin/home");
      } else if (roles === "member") {
        navigate("/member/home");
      } else {
        navigate("/");
      }
      return {
        access_token: window.localStorage.setItem("access_token", access_token),
        refresh_token: window.localStorage.setItem(
          "refresh_token",
          refresh_token
        ),
        user_name: window.localStorage.setItem("user_name", user_name),
      };
    } catch (err) {
      setErrorMessage(err?.response?.data?.message);
      setShowError(true);
      console.log(err);
    }
    setEnteredNameIsTouched(true);
    if (!enteredNameIsValid) {
      return;
    }

    setEnteredNameIsTouched(false);
    setEnteredPasswordIsTouched(true);
    if (!enteredPasswordIsValid) {
      return;
    }

    setEnteredPasswordIsTouched(false);
  };

  const nameInputBlurHandler = (e) => {
    setEnteredNameIsTouched(true);
  };

  const inpuFieldFocus = () => {
    setShowError(false);
  };

  const namePasswordBlurHandler = (e) => {
    setEnteredPasswordIsTouched(true);
  };

  return (
    <div className="fill-window">
      <div
        style={{
          width: "100%",
          height: "100%",
          // backgroundImage: "linear-gradient(#21b3d8, #54cae9)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="cards">
          <Paper elevation={2}>
            {
              <form
                onSubmit={handleSubmit}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "24px",
                }}
              >
                <img
                  src={favicon}
                  alt=""
                  height="100px"
                  width="100px"
                  className="userProfile"
                />
                <h3 className="h3Text">
                  <strong style={{ fontSize: "1.75rem" }}>
                    Login | Assabloy{" "}
                  </strong>
                </h3>
                <div className="form-text">
                  <TextField
                    id="outlined-basic"
                    error={nameInputIsValid}
                    autoComplete="off"
                    label="Username"
                    value={userName}
                    variant="outlined"
                    ref={userRef}
                    onFocus={inpuFieldFocus}
                    onBlur={nameInputBlurHandler}
                    onChange={handleInputChange}
                    style={{ textTransform: "capitalize" }}
                  />
                  {nameInputIsValid && (
                    <p className="error-text">Name must not be empty.</p>
                  )}
                </div>
                <div className="form-text">
                  <FormControl variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">
                      Password
                    </InputLabel>
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={handlePasswordChange}
                      onFocus={inpuFieldFocus}
                      onBlur={namePasswordBlurHandler}
                      // minLength="4"
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={hideShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                      ref={passwordRef}
                      error={passwordInputIsValid}
                    />
                  </FormControl>
                  {passwordInputIsValid && (
                    <p className="error-text">
                      Password length should be more than 4.
                    </p>
                  )}
                </div>
                {showError && (
                  <p style={{ marginLeft: "10px" }} className="error-text">
                    {errorMessage}
                  </p>
                )}
                <Button
                  type="submit"
                  disabled={!enabled}
                  variant="contained"
                  style={{
                    width: "40%",
                    marginTop: "20px",
                    padding: "10px",
                    marginBottom: "30px",
                  }}
                >
                  Sign In
                </Button>
              </form>
            }
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
